import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  // Replace these with your Firebase config values
  apiKey: "AIzaSyAzoT_wlxcwWlsH0x3VciAIy0MWMxGMFmU",
  authDomain: "mallard-notes.firebaseapp.com",
  projectId: "mallard-notes",
  storageBucket: "mallard-notes.firebasestorage.app",
  messagingSenderId: "31328696001",
  appId: "1:31328696001:web:8813ae049d905693084640",
  measurementId: "G-293WDWEXTZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app; 